export default {
  props: {
    invitations: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    isLoad: Boolean
  },

  data() {
    return {
      isLoadingModal: false,
      isShowConfirm: false,
      isShowUnConfirm: false,
      targetId: null
    }
  },

  methods: {
    handleConfirm(id) {
      this.isLoadingModal = false;
      this.isShowConfirm = true;
      this.targetId = id;
    },

    handleUnConfirm(id) {
      this.isLoadingModal = false;
      this.isShowUnConfirm = true;
      this.targetId = id;
    },

    async processConfirm(confirmFn, successMessage, dispatchAction, errorMessage) {
      this.isLoadingModal = true;
      try {
        const { data } = await confirmFn(this.targetId, this.userId);
        if (this.isSuccessResponse(data)) {
          this.isShowConfirm = false;
          this.isShowUnConfirm = false;
          this.targetId = null;

          this.$emit('refreshInvitations');

          if (dispatchAction) {
            await this.$store.dispatch(dispatchAction);
          }
          this.$toast.success(successMessage);
        }
      } catch {
        this.$toast.error(errorMessage);
      } finally {
        this.isLoadingModal = false;
      }
    },

    isSuccessResponse(data) {
      return data?.data || this.isSuccessStatus?.(data);
    }
  }
}